"use client";

import { c as _c } from "react/compiler-runtime";
import { FlexCenter, Media, Separator, SkeletonLine, TextLabel, tv } from "@opensea/ui-kit";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslations } from "use-intl";
import { AdjustForFeesSwitch } from "./AdjustForFeesSwitch";
import { FloorButton } from "./FloorButton";
import { LadderButton } from "./LadderButton";
import { ReserveButton } from "./ReserveButton";
import { SetPriceInput } from "./SetPriceInput";
import { TraitFloorButton } from "./TraitFloorButton";
const actionsVariants = tv({
  base: "grid gap-3 md:mr-10 md:flex xl:mr-0",
  variants: {
    bulk: {
      true: "grid-cols-4",
      false: "grid-cols-3"
    }
  }
});
export const ListingFlowHeaderActions = t0 => {
  const $ = _c(22);
  const {
    className,
    listingSymbol
  } = t0;
  const t = useTranslations("wallet.ListingFlowHeaderActions");
  const {
    control
  } = useFormContext();
  let t1;
  if ($[0] !== control) {
    t1 = {
      control,
      name: "listings"
    };
    $[0] = control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const listings = useWatch(t1);
  const t2 = listings.length > 1;
  let t3;
  if ($[2] !== className || $[3] !== t2) {
    t3 = actionsVariants({
      bulk: t2,
      className
    });
    $[2] = className;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ReserveButton />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <AdjustForFeesSwitch />;
    t6 = <Separator className="h-8" orientation="vertical" />;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  if ($[8] !== listings.length || $[9] !== t) {
    t7 = t("setPriceLabel", {
      count: listings.length
    });
    $[8] = listings.length;
    $[9] = t;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = <Media greaterThanOrEqual="md">{t5}{t6}<TextLabel className="whitespace-nowrap" size="2xs">{t7}</TextLabel></Media>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t10;
  let t11;
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <FloorButton />;
    t10 = <TraitFloorButton />;
    t11 = <LadderButton />;
    $[13] = t10;
    $[14] = t11;
    $[15] = t9;
  } else {
    t10 = $[13];
    t11 = $[14];
    t9 = $[15];
  }
  let t12;
  if ($[16] !== listingSymbol) {
    t12 = <SetPriceInput listingSymbol={listingSymbol} />;
    $[16] = listingSymbol;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t12 || $[19] !== t3 || $[20] !== t8) {
    t13 = <FlexCenter className={t3}>{t4}{t8}{t9}{t10}{t11}{t12}</FlexCenter>;
    $[18] = t12;
    $[19] = t3;
    $[20] = t8;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  return t13;
};
export const ListingFlowHeaderActionsSkeleton = t0 => {
  const $ = _c(18);
  const {
    className,
    count
  } = t0;
  const t = useTranslations("wallet.ListingFlowHeaderActions");
  const t1 = count > 1;
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = actionsVariants({
      bulk: t1,
      className
    });
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SkeletonLine className="h-8 w-[76px]" />;
    t4 = <SkeletonLine className="h-8 w-[120px]" />;
    t5 = <Separator className="h-8" orientation="vertical" />;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== count || $[7] !== t) {
    t6 = t("setPriceLabel", {
      count
    });
    $[6] = count;
    $[7] = t;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t6) {
    t7 = <Media greaterThanOrEqual="md">{t3}{t4}{t5}<TextLabel className="whitespace-nowrap" size="2xs">{t6}</TextLabel></Media>;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t10;
  let t11;
  let t8;
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <SkeletonLine className="h-8 w-full md:w-[58px]" />;
    t9 = <SkeletonLine className="h-8 w-full md:w-[88px]" />;
    t10 = <SkeletonLine className="h-8 w-full md:w-[68px]" />;
    t11 = <SkeletonLine className="h-8 w-full md:w-[120px]" />;
    $[11] = t10;
    $[12] = t11;
    $[13] = t8;
    $[14] = t9;
  } else {
    t10 = $[11];
    t11 = $[12];
    t8 = $[13];
    t9 = $[14];
  }
  let t12;
  if ($[15] !== t2 || $[16] !== t7) {
    t12 = <FlexCenter className={t2}>{t7}{t8}{t9}{t10}{t11}</FlexCenter>;
    $[15] = t2;
    $[16] = t7;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  return t12;
};